export default __webpack_public_path__ + "static/media/service.246930f8.jpg";